import * as React from "react";
import deepmerge from "deepmerge";
// import APIService from "../../../api/APIService";
// import { RESTService } from "../../../api/old/server_calls";
import GBApp from "../../../app/GBApp";
import * as GBConst from "../../GB/GBConst";
// import * as GBUtil from "../../GB/GBUtil";
import TSplashScreen from "../../common/TAppSplash";
import TAPIDialog from "../../common/TAPIDialog";
import TDialog from "../../common/TDialog";
import HLMain from "./HLMain";
import * as HLConst from "../NonVisual/HLConst";
import { callSuccessFn } from "../../GB/GBUtil";

class HLApp extends GBApp {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    /* This will be passed down through the component tree as "appState". In alphabetical order to
       preserve sanity.

       charCompareCountriesIntArray :
           max of three countries out of all countries represented by results after filtering

       countryCompareCountriesIntArray :
           subset of countries out of all countries represented by results after filtering

       disease1DObjArray:
           disease1DObjArray[diseaseCurrID]
           ex: {ID : 1, name : HIV}

       intervClass1DObjArray:
           intervClass1DObjArray[intervClassCurrID]
           ex: {ID : 1, name : prevention}

       interv3DObjArray:
           interv3DObjArray[diseaseCurrID, intervClassCurrID, intervCurrID]
           ex: {ID : 13, name : Male Condom Provision}

    */
    state = deepmerge(this.state, {
        drawerID: "",
        drawerOpen: false,
        failedToLoad: false,
        screenSize: GBConst.lgScreen,
        sideBarOpen: false,
        wideModeBool: false,

        countryCodeInt: HLConst.noCountrySelected,
        countryObjList: [],
        firstYearPop2DIntArray: [],
        intervAreaObjList: [],
        intervObjList: [],
        mortProfileCurrID: HLConst.mortProfile1,
        recalcBool: true,
        regionCurrID: HLConst.regEastAfrica,
        malariaEndemicBool: false,
        HIV_PrevCurrID: HLConst.highHIV_Prev,
        rankedIntervMstID2DObjArray: [],
        showAboutDialogBool: false,
        showMaternalIntervBool: true,
        showChildrenIntervBool: true,
        stuntingIndCurrID: HLConst.unsureNA_NutStatStunt,
        wastingIndCurrID: HLConst.unsureNA_NutStatWast,
        resultWkbkFileURLString: "",
    });

    componentDidMount() {
        this.onResize();
        window.addEventListener("resize", this.onResize);

        this.setState({
            pageID: HLConst.introForm,
            loading: false,
        });

        // NOTE: Delphi server is dead since Feb 2025
        //
        // this.runServices(() => {
        //     this.setDefaults(() => {
        //         this.setState({
        //             pageID: HLConst.introForm,
        //             loading: false,
        //         });
        //     });
        // });
    }

    // NOTE: Default server is dead since Feb 2025
    // /* This app uses containers. Every service call prompts the creation of a container,
    //    which can take up to a few seconds, so we want to minimize the number of service
    //    calls. We do this by calling RunServices to run all the initial service calls we
    //    need at once. */
    // runServices = (successFn) => {
    //     const gbu = GBUtil;

    //     const getCountryObjList_Response = 0;
    //     const getIntervObjList_Response = 1;
    //     const getIntervAreaObjList_Response = 2;

    //     let params = {
    //         serviceList: [],
    //     };

    //     /* REST service - Get LiST countries */
    //     params.serviceList.push({
    //         serviceName: "GetCountries",
    //         modID: 15,
    //         ignoreSampleCountry: true,
    //     });

    //     /* H-LiST service - Get intervention objects */
    //     params.serviceList.push({
    //         serviceName: "GetHLIntervObjList",
    //     });

    //     /* H-LiST service - Get intervention areas. */
    //     params.serviceList.push({
    //         serviceName: "GetIntervAreaObjList",
    //     });

    //     /* This will run services from both REST and UNFPA services. */
    //     RESTService.runServices(
    //         params,
    //         (response) => {
    //             const responseAsJSON = JSON.parse(response);
    //             const resultS = "result";
    //             const getCountryObjList_ResponseO = responseAsJSON[getCountryObjList_Response][resultS];
    //             const getIntervObjList_ResponseO = responseAsJSON[getIntervObjList_Response][resultS];
    //             const getIntervAreaObjList_ResponseO = responseAsJSON[getIntervAreaObjList_Response][resultS];

    //             this.getCountryObjList(getCountryObjList_ResponseO, () => {
    //                 this.getIntervObjList(getIntervObjList_ResponseO, () => {
    //                     this.getIntervAreaObjList(getIntervAreaObjList_ResponseO, () => {
    //                         this.setDefaults(() => {
    //                             gbu.callSuccessFn(successFn);
    //                         });
    //                     });
    //                 });
    //             });
    //         },
    //         () => {
    //             this.setState(
    //                 {
    //                     loading: false,
    //                     failedToLoad: true,
    //                 },
    //                 () => alert("An error occurred while initializing the app.")
    //             );
    //         }
    //     );
    // };

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }

    getCountryObjList = (response, successFn) => {
        const noCountryObj = {
            countryRegionCode: -1,
            countryRegionName: "Select a country",
        };

        let noCountryArray = [noCountryObj];

        let countryObjList = noCountryArray.concat(response);

        this.setState(
            {
                countryObjList: countryObjList,
            },
            () => callSuccessFn(successFn)
        );
    };

    getIntervObjList = (response, successFn) => {
        let intervObjList = response;

        this.setState(
            {
                intervObjList: intervObjList,
            },
            () => callSuccessFn(successFn)
        );
    };

    getIntervAreaObjList = (response, successFn) => {
        let intervAreaObjList = response;

        /* Add client-specific fields */
        for (let i = 1; i <= intervAreaObjList.length; i++) {
            intervAreaObjList[i - 1][HLConst.intervAreaObj.includeBool] = false;
            intervAreaObjList[i - 1][HLConst.intervAreaObj.scaleUpCurrID] = HLConst.noScaleUpSelected; //HLConst.scaleUp40t60Perc;
        }

        this.setState(
            {
                intervAreaObjList: intervAreaObjList,
            },
            () => callSuccessFn(successFn)
        );
    };

    setDefaults = (successFn) => {
        let firstYearPop2DIntArray = [];

        for (let a = 1; a <= HLConst.numAgeGroups; a++) {
            firstYearPop2DIntArray.push([]);

            for (let s = 1; s <= GBConst.numSexes; s++) {
                firstYearPop2DIntArray[a - 1].push(0);
            }
        }

        this.setState(
            {
                firstYearPop2DIntArray: firstYearPop2DIntArray,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onShowAboutDialogChange = (showAboutDialogBool) => {
        this.setState({
            showAboutDialogBool: showAboutDialogBool,
        });
    };

    onIncludeIntervAreaChange = (intervAreaCurrID, includeBool) => {
        let intervAreaObjList = JSON.parse(JSON.stringify(this.state.intervAreaObjList));
        let recalcBool = this.state.recalcBool;

        const includeBoolPrev = intervAreaObjList[intervAreaCurrID - 1].includeBool;

        if (includeBoolPrev !== includeBool) {
            recalcBool = true;
        }

        intervAreaObjList[intervAreaCurrID - 1].includeBool = includeBool;

        this.setState({
            intervAreaObjList: intervAreaObjList,
            recalcBool: recalcBool,
        });
    };

    onIntervAreaScaleUpChange = (intervAreaCurrID, scaleUpCurrID) => {
        let intervAreaObjList = JSON.parse(JSON.stringify(this.state.intervAreaObjList));
        let recalcBool = this.state.recalcBool;

        const scaleUpCurrIDPrev = intervAreaObjList[intervAreaCurrID - 1].scaleUpCurrID;

        if (scaleUpCurrIDPrev !== scaleUpCurrID) {
            recalcBool = true;
            /* Assume that if the user is choosing a scale-up, then the user wants the
               intervention area included in the analysis. */
            intervAreaObjList[intervAreaCurrID - 1].includeBool = true;
        }

        intervAreaObjList[intervAreaCurrID - 1].scaleUpCurrID = scaleUpCurrID;

        this.setState({
            intervAreaObjList: intervAreaObjList,
            recalcBool: recalcBool,
        });
    };

    /* Defunct */
    onMortProfileChange = (mortProfileCurrID) => {
        this.setState({
            mortProfileCurrID: mortProfileCurrID,
        });
    };

    onRankedIntervMstIDArrayChange = (rankedIntervMstID2DObjArray, successFn) => {
        this.setState(
            {
                rankedIntervMstID2DObjArray: rankedIntervMstID2DObjArray,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    onRecalcChange = (recalcBool, successFn) => {
        this.setState(
            {
                recalcBool: recalcBool,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    /* Defunct */
    onRegionChange = (regionCurrID) => {
        this.setState({
            regionCurrID: regionCurrID,
        });
    };

    onResultWkbkFileURLChange = (resultWkbkFileURLString, successFn) => {
        this.setState(
            {
                resultWkbkFileURLString: resultWkbkFileURLString,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    /* Defunct */
    onMalariaEndemicChange = (malariaEndemicBool) => {
        this.setState({
            malariaEndemicBool: malariaEndemicBool,
        });
    };

    /* Defunct */
    onHIV_PrevChange = (HIV_PrevCurrID) => {
        this.setState({
            HIV_PrevCurrID: HIV_PrevCurrID,
        });
    };

    onCountryChange = (countryCodeInt, successFn) => {
        const countryCodeIntPrev = this.state.countryCodeInt;
        let recalcBool = this.state.recalcBool;

        if (countryCodeIntPrev !== countryCodeInt) {
            recalcBool = true;
        }

        this.setState(
            {
                countryCodeInt: countryCodeInt,
                recalcBool: recalcBool,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    onFirstYearPopChange = (firstYearPop2DIntArray, successFn) => {
        const firstYearPop2DIntArrayPrev = this.state.firstYearPop2DIntArray;
        let recalcBool = this.state.recalcBool;

        if (JSON.stringify(firstYearPop2DIntArrayPrev) !== JSON.stringify(firstYearPop2DIntArray)) {
            recalcBool = true;
        }

        this.setState(
            {
                firstYearPop2DIntArray: firstYearPop2DIntArray,
                recalcBool: recalcBool,
            },
            () => callSuccessFn(successFn)
        );
    };

    onStuntingIndChange = (stuntingIndCurrID) => {
        const stuntingIndCurrIDPrev = this.state.stuntingIndCurrID;
        let recalcBool = this.state.recalcBool;

        if (stuntingIndCurrIDPrev !== stuntingIndCurrID) {
            recalcBool = true;
        }

        this.setState({
            recalcBool: recalcBool,
            stuntingIndCurrID: stuntingIndCurrID,
        });
    };

    onWastingIndChange = (wastingIndCurrID) => {
        const wastingIndCurrIDPrev = this.state.wastingIndCurrID;
        let recalcBool = this.state.recalcBool;

        if (wastingIndCurrIDPrev !== wastingIndCurrID) {
            recalcBool = true;
        }

        this.setState({
            recalcBool: recalcBool,
            wastingIndCurrID: wastingIndCurrID,
        });
    };

    onShowMaternalIntervChange = (showMaternalIntervBool) => {
        this.setState({
            showMaternalIntervBool: showMaternalIntervBool,
        });
    };

    onShowChildrenIntervChange = (showChildrenIntervBool) => {
        this.setState({
            showChildrenIntervBool: showChildrenIntervBool,
        });
    };

    onResize = () => {
        let screenSize = GBConst.lgScreen;

        if (window.innerWidth <= GBConst.smScreen) {
            screenSize = GBConst.smScreen;
        } else if (window.innerWidth <= GBConst.mdScreen) {
            screenSize = GBConst.mdScreen;
        }

        this.setState({
            //wideModeBool : window.innerWidth > 1150,
            screenSize: screenSize,
        });
    };

    onSideBarArrowClick = (sideBarOpenBool, successFn) => {
        let bool;

        if (typeof sideBarOpenBool === "undefined") {
            bool = !this.state.sideBarOpen;
        } else {
            bool = sideBarOpenBool;
        }

        this.setState(
            {
                sideBarOpen: bool,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    onPageChange = (pageIDByte) => {
        this.setState({
            pageID: pageIDByte,
        });
    };

    onDrawerChange = (drawerID, successFn, errorFn) => {
        if (typeof drawerID === "undefined" || drawerID === "") {
            this.setState(
                {
                    drawerID: "",
                    drawerOpen: false,
                },
                successFn
            );
        } else {
            this.setState(
                {
                    drawerID: drawerID,
                    drawerOpen: true,
                },
                successFn
            );
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        /* State */
        const state = this.state;

        const mainComp = (
            <HLMain
                key={this.state.pageID}
                apiTasks={state.apiTasks}
                appState={state}
                onStateChange={this.onStateChange}
                onDrawerChange={this.onDrawerChange}
                onSideBarArrowClick={this.onSideBarArrowClick}
                heartBeat={state.heartBeat}
                onPageChange={this.onPageChange}
                onCountryChange={this.onCountryChange}
                onFirstYearPopChange={this.onFirstYearPopChange}
                onHIV_PrevChange={this.onHIV_PrevChange}
                onIncludeIntervAreaChange={this.onIncludeIntervAreaChange}
                onIntervAreaScaleUpChange={this.onIntervAreaScaleUpChange}
                onMalariaEndemicChange={this.onMalariaEndemicChange}
                onMortProfileChange={this.onMortProfileChange}
                onRankedIntervMstIDArrayChange={this.onRankedIntervMstIDArrayChange}
                onRecalcChange={this.onRecalcChange}
                onRegionChange={this.onRegionChange}
                onResultWkbkFileURLChange={this.onResultWkbkFileURLChange}
                onShowAboutDialogChange={this.onShowAboutDialogChange}
                onShowChildrenIntervChange={this.onShowChildrenIntervChange}
                onShowMaternalIntervChange={this.onShowMaternalIntervChange}
                onStuntingIndChange={this.onStuntingIndChange}
                onWastingIndChange={this.onWastingIndChange}
            />
        );

        // const APIServiceComp = (
        //     <APIService
        //         apiTasks={state.apiTasks}
        //         appState={state}
        //         onIncrementCallsSent={this.onIncrementCallsSent}
        //         onIncrementCallsSuccess={this.onIncrementCallsSuccess}
        //         onIncrementCallsError={this.onIncrementCallsError}
        //         onIncrementCallsFail={this.onIncrementCallsFail}
        //         onStateChange={this.onStateChange}
        //         onProjectionAdd={this.onProjectionAdd}
        //     />
        // );

        const APIDialogComp = <TAPIDialog apiTasks={state.apiTasks} />;

        const commWithServerDialog = (
            <TDialog
                caption={"Communicating with server..."}
                modal={true}
                visible={false} //this.state.processingServerCall}
                style={{
                    width: "370px",
                }}
            />
        );

        if (state.loading) {
            return (
                <div>
                    <TSplashScreen />
                    {/* {APIServiceComp} */}
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    {mainComp}
                    {/* {APIServiceComp} */}
                    {APIDialogComp}
                    {commWithServerDialog}
                </React.Fragment>
            );
        }
    }
}

export default HLApp;
